import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { MotionConfig } from 'motion/react';
import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { setUnauthorizedHandler } from '@/lib/api/client';
import { useTheme, watchSystemTheme } from '@/lib/theme';
import { createQueryClient } from './query-client';
import { createAppRouter } from './router';

export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createAppRouter(queryClient));
  const { resolved } = useTheme();

  useEffect(() => watchSystemTheme(), []);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      queryClient.clear();
      const { pathname, searchStr } = router.state.location;
      if (pathname.startsWith('/login')) return;
      void router.navigate({ to: '/login', search: { redirect: pathname + searchStr } });
    });
  }, [queryClient, router]);

  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user" transition={{ ease: [0.22, 1, 0.36, 1] }}>
        <TooltipProvider delayDuration={250} skipDelayDuration={150}>
          <RouterProvider router={router} />
          <Toaster
            position="bottom-right"
            theme={resolved}
            closeButton
            richColors={false}
            toastOptions={{
              classNames: {
                toast: '!rounded-lg !border !border-border !bg-surface !text-fg !shadow-e3 !font-sans',
                description: '!text-fg-muted',
                success: '[&_[data-icon]]:!text-success',
                error: '[&_[data-icon]]:!text-danger',
              },
            }}
          />
        </TooltipProvider>
      </MotionConfig>
    </QueryClientProvider>
  );
}
